export default "__VITE_ASSET__BCJmD2aQ__"